var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "base-card",
        { staticClass: "relative" },
        [
          _vm.floatingButtonBackgroundColor
            ? _c(
                "v-btn",
                {
                  attrs: {
                    absolute: "",
                    fab: "",
                    right: "",
                    top: "",
                    "x-small": "",
                    color: _vm.floatingButtonBackgroundColor,
                  },
                },
                [
                  _c("v-icon", { class: _vm.floatingButtonIconTextColor }, [
                    _vm._v(" " + _vm._s(_vm.floatingButtonIconName) + " "),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c("v-card-text", [
            _c(
              "div",
              { staticClass: "d-flex flex-column justify-center align-center" },
              [
                _c(
                  "v-sheet",
                  {
                    staticClass:
                      "rounded-circle d-flex align-center justify-center mb-4",
                    class: _vm.mainIconBackgroundColorClass,
                    attrs: { height: "40", width: "40" },
                  },
                  [
                    _c("v-icon", { class: _vm.mainIconTextColor }, [
                      _vm._v(" " + _vm._s(_vm.mainIconName) + " "),
                    ]),
                  ],
                  1
                ),
                _c("h3", { staticClass: "font-weight-bold ma-0" }, [
                  _vm._v(" " + _vm._s(_vm.headingText) + " "),
                ]),
                _c("h6", { staticClass: "caption mb-8 font-weight-regular" }, [
                  _vm._v(" " + _vm._s(_vm.subHeadingText) + " "),
                ]),
                _c(
                  "v-btn",
                  {
                    staticClass:
                      "caption hover:white--text font-weight-bold py-2 px-4 d-inline-flex align-center",
                    class: [
                      _vm.mainIconTextColor,
                      _vm.mainIconBackgroundColorClass,
                      _vm.bottomButtonHoverClass,
                    ],
                    attrs: { depressed: "", rounded: "" },
                  },
                  [
                    _c("v-icon", { staticClass: "caption mr-1" }, [
                      _vm._v(" " + _vm._s(_vm.bottomButtonIcon) + " "),
                    ]),
                    _c("span", {}, [_vm._v(_vm._s(_vm.bottomButtonText))]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }